import React from "react";
import { css } from "@emotion/css";

const overlayStyle = css`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
`;

const dialogStyle = css`
    background-color: white;
    border-radius: 8px;
    padding: 24px;
    width: 90%;
    max-width: 500px;
    box-shadow: 0 4px 6px rgba(0,0,0,0.1);
`;

const titleStyle = css`
    font-size: 20px;
    font-weight: 600;
    margin-top: 0;
    margin-bottom: 16px;
    color: #333;
`;

const descStyle = css`
    font-size: 15px;
    color: #555;
    margin-bottom: 24px;
`;

const detailsRowStyle = css`
    display: flex;
    justify-content: space-between;
    margin-top: 10px;
    font-size: 15px;
    color: #333;
`;

const legalLinksStyle = css`
    display: flex;
    justify-content: flex-end;
    gap: 16px;
    margin-top: 24px;
    margin-bottom: 24px;
`;

const linkStyle = css`
    font-size: 14px;
    color: #0062FF;
    text-decoration: none;
    &:hover {
        text-decoration: underline;
    }
`;

const actionsStyle = css`
    display: flex;
    justify-content: flex-end;
    gap: 12px;
`;

const buttonOutlinedStyle = css`
    padding: 8px 16px;
    border-radius: 4px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    background-color: white;
    color: #1976d2;
    border: 1px solid rgba(25, 118, 210, 0.5);
    &:hover {
        border-color: #1976d2;
        background-color: rgba(25, 118, 210, 0.04);
    }
`;

const buttonSuccessStyle = css`
    padding: 8px 16px;
    border-radius: 4px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    background-color: white;
    color: #2e7d32;
    border: 1px solid rgba(46, 125, 50, 0.5);
    &:hover {
        border-color: #2e7d32;
        background-color: rgba(46, 125, 50, 0.04);
    }
`;

const RegistrationPaymentDialog = ({ state, onClose, onSubmit }) => {
    if (!state) return null;

    return (
        <div className={overlayStyle}>
            <div className={dialogStyle}>
                <h2 className={titleStyle}>User Registration</h2>
                <div style={{ marginBottom: "16px" }}>
                    <p className={descStyle}>
                        To complete your registration and start booking events, please pay the one-time registration fee.
                    </p>
                    <div className={detailsRowStyle}>
                        <span>Name</span>
                        <span>{state.name}</span>
                    </div>
                    <div className={detailsRowStyle}>
                        <span>Mobile</span>
                        <span>{state.mobile}</span>
                    </div>
                    <div className={detailsRowStyle}>
                        <span>Email</span>
                        <span>{state.email}</span>
                    </div>
                    <div className={legalLinksStyle}>
                        <a
                            className={linkStyle}
                            target="_blank"
                            rel="noreferrer"
                            href="https://global.eonlineworkshop.com/g_privacypolicy_refund.html"
                        >
                            Privacy Policy
                        </a>
                        <a
                            className={linkStyle}
                            target="_blank"
                            rel="noreferrer"
                            href="https://global.eonlineworkshop.com/g_termsnconditions.html"
                        >
                            Terms & Conditions
                        </a>
                    </div>
                </div>
                <div className={actionsStyle}>
                    <button className={buttonOutlinedStyle} onClick={onClose}>
                        Cancel
                    </button>
                    <button className={buttonSuccessStyle} onClick={onSubmit}>
                        Make Payment
                    </button>
                </div>
            </div>
        </div>
    );
};

export default RegistrationPaymentDialog;
